import { calcularValorComDesconto } from 'app/utils/monetarioUtil';
import { servicoApi } from 'app/services/api/servicoApi';
import { useFormikContext } from 'formik';
import moment from 'moment-timezone';
import React, { useState } from 'react';
import { AdesaoContrato, AnexoContrato, DadosContrato, PagamentoContrato } from './secoes';
import ReajusteAutomatico from './secoes/ReajusteAutomatico';

const ContratoCadastroForm = () => {
  const [valorAlteradoManualmente, setValorAlteradoManualmente] = useState(false);
  const formikContext = useFormikContext();
  const { values, handleChange, handleBlur, errors, touched, submitCount } = formikContext;

  const _errors = {
    cliente: (submitCount > 0 || touched?.cliente) && errors?.cliente,
    dataVigenciaInicial: (submitCount > 0 || touched?.dataVigenciaInicial) && errors?.dataVigenciaInicial,
    dataVigenciaFinal: (submitCount > 0 || touched?.dataVigenciaFinal) && errors?.dataVigenciaFinal,
    vigenciaIndeterminada: (submitCount > 0 || touched?.vigenciaIndeterminada) && errors?.vigenciaIndeterminada,
    servicos: values?.servicos?.map((servico, index) => {
      return {
        servico:
          (submitCount > 0 || (touched?.servicos && touched?.servicos[index]?.servico)) &&
          errors?.servicos &&
          errors?.servicos[index]?.servico,
        valor:
          (submitCount > 0 || (touched?.servicos && touched?.servicos[index]?.valor)) &&
          errors?.servicos &&
          errors?.servicos[index]?.valor,
      };
    }),
    categorias: values?.categorias?.map((categoria, index) => {
      return {
        classe:
          (submitCount > 0 || (touched?.categorias && touched?.categorias[index]?.classe)) &&
          errors?.categorias &&
          errors?.categorias[index]?.classe,
        valorBruto:
          (submitCount > 0 || (touched?.categorias && touched?.categorias[index]?.valorBruto)) &&
          errors?.categorias &&
          errors?.categorias[index]?.valorBruto,
      };
    }),
    imovel: (submitCount > 0 || touched?.imovel) && errors?.imovel,
    valor: (submitCount > 0 || touched?.valor) && errors?.valor,
    vencimentoCobranca: (submitCount > 0 || touched?.vencimentoCobranca) && errors?.vencimentoCobranca,
    formaCobranca: (submitCount > 0 || touched?.formaCobranca) && errors?.formaCobranca,
    formaRecebimentoPrimeiraCobranca:
      (submitCount > 0 || touched?.formaRecebimentoPrimeiraCobranca) && errors?.formaRecebimentoPrimeiraCobranca,
    dataVencimentoPrimeiraCobranca:
      (submitCount > 0 || touched?.dataVencimentoPrimeiraCobranca) && errors?.dataVencimentoPrimeiraCobranca,
    emailsCliente: values.emailsCliente?.map((email, index) => {
      return (
        (submitCount > 0 || (touched?.emailsCliente && touched?.emailsCliente[index])) &&
        errors?.emailsCliente &&
        errors?.emailsCliente[index]
      );
    }),
    adesao: {
      servico: (submitCount > 0 || touched?.adesao?.servico) && errors?.adesao?.servico,
      categoria: (submitCount > 0 || touched?.adesao?.categoria) && errors?.adesao?.categoria,
      valor: (submitCount > 0 || touched?.adesao?.valor) && errors?.adesao?.valor,
      formaCobranca: (submitCount > 0 || touched?.adesao?.formaCobranca) && errors?.adesao?.formaCobranca,
      dataVencimento: (submitCount > 0 || touched?.adesao?.dataVencimento) && errors?.adesao?.dataVencimento,
    },
  };

  const atualizarValorComDesconto = (id, servico, vigenciaInicial) => {
    let dataInicioPromocao;
    let dataFimPromocao;
    let dataVigenciaInicial;

    if (servico) {
      dataInicioPromocao = servico?.promocao?.vigenciaInicio;
      dataFimPromocao = servico?.promocao?.vigenciaFim;
      dataVigenciaInicial =
        values.dataVigenciaInicial !== undefined && moment(values.dataVigenciaInicial).format('YYYY-MM-DD');
    } else if (vigenciaInicial) {
      servico = values.servico;
      dataInicioPromocao = values.servico?.promocao?.vigenciaInicio;
      dataFimPromocao = values.servico?.promocao?.vigenciaFim;
      dataVigenciaInicial = vigenciaInicial !== undefined && moment(vigenciaInicial).format('YYYY-MM-DD');
    }

    if (
      dataInicioPromocao &&
      dataFimPromocao &&
      dataVigenciaInicial >= dataInicioPromocao &&
      dataVigenciaInicial <= dataFimPromocao
    ) {
      const tipo = servico.promocao?.tipo;

      const valorPromocional = calcularValorComDesconto(tipo, servico?.valorVenda, servico?.promocao?.valor);

      formikContext.setFieldValue(id, valorPromocional);
    }
  };

  const handleChangeServico = (e, index) => {
    handleChange(e);

    const id = e.target.id.includes('adesao') ? 'adesao.valor' : 'categorias[0].valorBruto';

    // RNE-523
    if (e.target.value?.valorVenda) {
      atualizarValorComDesconto(id, e.target.value);

      if (id === 'categorias[0].valorBruto') {
        setValorAlteradoManualmente(false);
      }
    } else if (!valorAlteradoManualmente) {
      //formikContext.setFieldValue(id, '');
      //formikContext.setFieldValue(id, '');
    }

    const mapServicoFiscalFromServico = (fiscal) => ({
      cnaeId: fiscal?.cnae?.id,
      lc116Id: fiscal?.lc116?.id,
      lc116Convertido: fiscal?.lc116Convertido,
      codigoServicoMunicipal: fiscal?.codigoServicoMunicipal,

      tipoIss: fiscal?.tipoIss,
      valorIss: fiscal?.valorIss,
      issRetidoNaFonte: fiscal?.issRetidoNaFonte,

      tipoPis: fiscal?.tipoPis,
      valorPis: fiscal?.valorPis,
      pisRetidoNaFonte: fiscal?.pisRetidoNaFonte,

      tipoCofins: fiscal?.tipoCofins,
      valorCofins: fiscal?.valorCofins,
      cofinsRetidoNaFonte: fiscal?.cofinsRetidoNaFonte,

      tipoInss: fiscal?.tipoInss,
      valorInss: fiscal?.valorInss,
      inssRetidoNaFonte: fiscal?.inssRetidoNaFonte,

      tipoIrrf: fiscal?.tipoIrrf,
      valorIrrf: fiscal?.valorIrrf,
      irrfRetidoNaFonte: fiscal?.irrfRetidoNaFonte,

      tipoCsll: fiscal?.tipoCsll,
      valorCsll: fiscal?.valorCsll,
      csllRetidoNaFonte: fiscal?.csllRetidoNaFonte,

      tipoIbs: fiscal?.tipoIbs,
      valorIbs: fiscal?.valorIbs,
      ibsRetidoNaFonte: fiscal?.ibsRetidoNaFonte,

      tipoIbsMunicipal: fiscal?.tipoIbsMunicipal,
      valorIbsMunicipal: fiscal?.valorIbsMunicipal,

      tipoCbs: fiscal?.tipoCbs,
      valorCbs: fiscal?.valorCbs,
      cbsRetidoNaFonte: fiscal?.cbsRetidoNaFonte,

      tipoIs: fiscal?.tipoIs,
      valorIs: fiscal?.valorIs,
      isRetidoNaFonte: fiscal?.isRetidoNaFonte,

      possuiIbsCbs: fiscal?.possuiIbsCbs,
      cstSituacaoTributaria: fiscal?.cstSituacaoTributaria || null,
      cstClassificacaoTributaria: fiscal?.cstClassificacaoTributaria || null,
    });

    if (e?.target?.id.includes('servicos')) {
      handleChange({
        target: {
          id: `servicos[${index}].servicoFiscal`,
          value: mapServicoFiscalFromServico(e?.target?.value?.fiscal),
        },
      });
    }

    if (e?.target?.id === 'adesao.servico') {
      if (e?.target?.value?.id) {
        servicoApi.getOne(e.target.value.id).then((response) => {
          formikContext.setFieldValue(
            'adesao.servicoFiscal',
            mapServicoFiscalFromServico(response.data?.fiscal)
          );
        });
      } else {
        formikContext.setFieldValue('adesao.servicoFiscal', {});
      }
    }
  };

  const handleChangeVigenciaInicial = (event) => {
    if (!valorAlteradoManualmente) {
      atualizarValorComDesconto('categorias[0].valorBruto', undefined, event.target.value);
    }
  };

  const handleChangeValorPrimeiraCategoria = (event) => {
    handleChange(event);
    setValorAlteradoManualmente(true);
  };

  const handleChangePeriodicidade = (event) => {
    handleChange(event);
    if (event.target.value === 'ANUAL') {
      formikContext.setFieldValue('recebimentoDiferentePrimeiraCobranca', false);
      const resetEvent = {
        target: { id: 'periodoVigencia', value: 'Anual' },
      };
      handleChange(resetEvent);
    }
  };

  return (
    <div className="h-full max-h-full w-full">
      <DadosContrato
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        handleChangeServico={handleChangeServico}
        handleChangePeriodicidade={handleChangePeriodicidade}
        handleChangeVigenciaInicial={handleChangeVigenciaInicial}
        handleChangeValorPrimeiraCategoria={handleChangeValorPrimeiraCategoria}
        errors={_errors}
      />

      <PagamentoContrato values={values} handleChange={handleChange} handleBlur={handleBlur} errors={_errors} />

      <ReajusteAutomatico
        values={values?.reajusteAutomatico}
        handleChange={handleChange}
        handleBlur={handleBlur}
        errors={errors}
        touched={touched}
        submitCount={submitCount}
      />

      <AdesaoContrato
        values={values.adesao}
        handleChange={handleChange}
        handleBlur={handleBlur}
        handleChangeServico={handleChangeServico}
        errors={_errors.adesao}
        isContratoCobrancaBaixadaOuRemessaGerada={values?.adesao?.isCobrancaBaixadaOuRemessaGerada}
      />

      <AnexoContrato values={values} handleChange={handleChange} />
    </div>
  );
};

export default ContratoCadastroForm;
